import { defineStore } from "pinia";
import axios from "axios";
import { ActorStore } from "./actorStore";
import { AssetStore } from "./assetStore";
import { CategoriesStore } from "./categoriesStore";
import { useCounterStore } from "./counter";
import { DataEnrichmentStore } from "./dataEnrichmentStore";
import { DirectorStore } from "./directorStore";
import { FavoriteStore } from "./favoriteStore";
import { GenresStore } from "./genresStore";
import { ProfileStore } from "./profileStore";
import { SessionStore } from "./sessionStore";
import { UIStore } from "./uiStore";

type UserAccountState = {
  token: string | null;
  validdate: string | null;
  plan: string;
  active_subscription?: string | null;
  gateway?: string | null;
  accesscontrol?: boolean;
  payment_status?: string | null;
  [key: string]: any;
};

export const UserStore = defineStore("userStore", {
  state: () => ({
    entrypoint: null,
    selectedLanguage: "es",
    token: "",
    flMark: "",
    userAccount: {
      user_id: null,
      token: null,
      validdate: null,
      plan: "",
    } as UserAccountState,
  }),
  actions: {
    clearEntrypoint() {
      this.entrypoint = null;
    },
    setFlMark(flMark: string) {
      this.flMark = flMark;
    },
    setEntrypoint(entrypoint: string) {
      // @ts-ignore
      this.entrypoint = entrypoint === "" ? null : entrypoint;
    },
    logout() {
      const actorStore = ActorStore();
      const assetStore = AssetStore();
      const categoriesStore = CategoriesStore();
      const counterStore = useCounterStore();
      const dataEnrichmentStore = DataEnrichmentStore();
      const directorStore = DirectorStore();
      const favoriteStore = FavoriteStore();
      const genresStore = GenresStore();
      const profileStore = ProfileStore();
      const sessionStore = SessionStore();
      const uiStore = UIStore();

      actorStore.$reset();
      assetStore.$reset();
      categoriesStore.$reset();
      counterStore.count = 0;
      dataEnrichmentStore.$reset();
      directorStore.$reset();
      favoriteStore.$reset();
      genresStore.$reset();
      profileStore.$reset();
      sessionStore.$reset();
      uiStore.$reset();
      this.$reset();

      axios.defaults.params = {};

      if (typeof window !== "undefined") {
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.sessionStorage.setItem("flx:home:force-reload", "1");
      }
    },
    setLanguage(language: string | string[]) {
      axios.defaults.params = {};
      axios.defaults.params["lang"] = language;
      this.selectedLanguage = language.toString();
    },

    setAccountStatus(status: string) {
      // @ts-ignore
      this.userAccount.payment_status = status;
    },

    setToken(token: string) {
      this.token = token;
    },
    setAccount(profile: object) {
      this.userAccount = profile as UserAccountState;
    },
  },
  getters: {
    getFlMark(): string {
      return this.flMark;
    },
    getEntrypoint(): string {
      // @ts-ignore
      return this.entrypoint;
    },
    getLanguage(): string {
      return this.selectedLanguage;
    },
    trialEntitlement(): boolean {
      // Treat only subscription-backed trial accounts as trial entitled.
      // Free magic-link accounts can also have active_subscription === "0",
      // but they should not be routed through the paid trial flow.
      return (
        this.userAccount?.active_subscription === "0" &&
        !!this.userAccount?.gateway
      );
    },
    getToken(): string {
      return this.token;
    },
    getAccount(): any {
      return this.userAccount;
    },
    isLoggedIn(): boolean {
      return this.token !== "";
    },
    fullyEntitled(): boolean {
      // @ts-ignore
      return this.userAccount.active_subscription === "1";
    },
    isEntitled(): boolean {
      // @ts-ignore
      return this.token !== "";
    },
    isPaidUser(): boolean {
      // @ts-ignore
      if (!this.userAccount.gateway) {
        return false;
      }
      // @ts-ignore
      return this.userAccount.accesscontrol; // this.userAccount.valid !== null;
    },
    getPlan(): string {
      // @ts-ignore
      if (this.userAccount?.plan === "0") {
        return "basic";
      } else if (this.userAccount?.plan === "2") {
        return "premium";
      }
      return "none";
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: "flxUser",
        storage: localStorage,
      },
    ],
  },
});
